import * as React from 'react';

import { LayoutMode } from './types';

interface LayoutModeContextValue {
	layoutMode: LayoutMode;
	setLayoutMode: React.Dispatch<React.SetStateAction<LayoutMode>>;
}

const LayoutModeContext = React.createContext<LayoutModeContextValue>(null!);

interface LayoutModeProviderProps {
	layoutMode: LayoutMode;
	setLayoutMode: React.Dispatch<React.SetStateAction<LayoutMode>>;
	children: React.ReactNode;
}

export const LayoutModeProvider: React.FC<LayoutModeProviderProps> = ({ layoutMode, setLayoutMode, children }) => {
	const value = React.useMemo(() => ({ layoutMode, setLayoutMode }), [layoutMode, setLayoutMode]);

	return <LayoutModeContext.Provider value={value}>{children}</LayoutModeContext.Provider>;
};

export function useLayoutMode(): LayoutMode {
	return React.useContext(LayoutModeContext).layoutMode;
}

export function useSetLayoutMode(): React.Dispatch<React.SetStateAction<LayoutMode>> {
	return React.useContext(LayoutModeContext).setLayoutMode;
}
